/**
 * ページ内差し替えプレイヤー
 *
 * サムネイルをクリックすると同じ場所に iframe を埋め込む。
 * YouTube の標準コントロール（再生・停止・音量・全画面）を有効にする。
 */

export function setupInline( block, config ) {
	const log = config?.log || ( () => {} );
	block.addEventListener( 'click', ( e ) => {
		const link = e.target.closest( '.sab-yt-card__thumb-link[data-play-mode="inline"]' );
		if ( ! link ) return;
		e.preventDefault();

		const card    = link.closest( '.sab-yt-card' );
		const videoId = card?.dataset.videoId;
		if ( ! videoId ) return;

		// すでに iframe がある場合はスキップ
		if ( link.querySelector( 'iframe' ) ) {
			log( `INLINE already playing videoId=${ videoId }` );
			return;
		}
		log( `INLINE play videoId=${ videoId }` );

		const iframe = document.createElement( 'iframe' );
		// controls=1 でコントロールバーを表示、autoplay=1 で即再生
		iframe.src         = `https://www.youtube-nocookie.com/embed/${ encodeURIComponent( videoId ) }?autoplay=1&rel=0&controls=1`;
		iframe.title       = 'YouTube video player';
		iframe.frameBorder = '0';
		iframe.allow       = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
		iframe.allowFullscreen = true;
		iframe.className   = 'sab-yt-inline-player';

		// サムネイル・再生ボタンを iframe で置換
		link.innerHTML = '';
		link.appendChild( iframe );
		// リンクの href によるページ遷移を防ぐが、iframe 内操作は妨げない
		link.style.pointerEvents = 'none';
		iframe.style.pointerEvents = 'auto';
	} );
}